// extracted by mini-css-extract-plugin
module.exports = {"container":"container_container__2g2SU","contents":"container_contents__1rYe_"};